var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xmaxMap"},[_c('Map'),_c('top'),_c('bottom',{ref:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }